import { createActionName } from './naming';
import * as types from './actionsTypes';

export const sendForm = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SEND_FORM),
  payload
});

export const setFieldModelClass = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_FIELD_MODEL_CLASS),
  payload
});

export const setFieldModelId = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_FIELD_MODEL_ID),
  payload
});

export const setFieldParentId = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_FIELD_PARENT_ID),
  payload
});

export const setFieldContent = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_FIELD_CONTENT),
  payload
});

export const setFieldLike = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_FIELD_LIKE),
  payload
});

export const setResultObject = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_RESULT_OBJECT),
  payload
});

export const initState = reducerName => ({
  type: createActionName(reducerName, types.INIT_STATE)
});



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/comments/reducers/form/actions.js